export class Produtos {
  ativado = null;
  codigo = null;
  codigoBarra = null;
  grupoProdutoId = null;
  subgrupoProdutoId = null;
  familiaProdutoId = null;
  subfamiliaProdutoId = null;
  tipo = null;
  descricao = null;
  unidadeComercialCompraId = null;
  unidadeComercialVendaId = null;
  conversorEntrada = null;
  estoqueAtual = null;
  estoque = null;
  fracionavel = null;
  lerPesoPorBalanca = null;
  precoCompra = null;
  precoCusto = null;
  precoVenda = null;
  precoMedio = null;
  lucroDesejado = null;
  grupoTributacaoId = null;
  tipoItemId = null;
  ncmId = null;
  ncmCodigo = null;
  cestId = null;
  gtin = null;
  origemMercadoriaId = null;
  aliquotaMva = null;
  informacaoAdicionalNfe = null;
  informacaoComplementar = null;
  produtosSimilaresIds = [];
  produtosKitIds = [];
  fornecedores = [];
  produtosGrade = [];
  tagsIds = [];
  hubVendas = null;
  altura = null;
  largura = null;
  comprimento = null;
  peso = null;
  dataValidade = null;
  dataFabricacao = null;
  precoMaxConsumo = null;
  numLote = null;
  qtdLote = null;
  agregado = null;
  isMedicamento = false;
  isCombustivel = false;
  prodAnvisa = null;
  motivoIsencao = null;
  anpCodigo = null;
  anpDescricao = null;
  unidadeTributavelId = null;
  anpDescricao = null;
  unidadeTributavelId = null;
  qtdTributavel = null;
  glp = null;
  gasNaturalNacional = null;
  gasNaturalImp = null;
  valorPartida = null;
  codif = null;
  qtdCombTempAmbiente = null;
  bcCide = null;
  aliquotaCide = null;
  bcCide = null;
  aliquotaCide = null;
  valorCide = null;
  indicadorImportacao = null;
  ufOrigem = null;
  percentualUf = null;
  referenciaPeca = null;
  enderecoEstoque = null;

  constructor(
    dadosCsv,
    listaNcm = [],
    listaCest = [],
    listaEnderecoEstoque = [],
  ) {
    const ncmEncontrado = listaNcm.find(
      (ncm) => ncm.codigo === String(dadosCsv.ncm),
    );
    const cestEncontrado = listaCest.find(
      (cest) =>
        cest.codigo === String(dadosCsv.cest) &&
        cest.ncm === String(dadosCsv.ncm),
    );

    this.ativado = dadosCsv.ativado;
    this.codigo = dadosCsv.codigo;
    this.setCodigoBarra(dadosCsv.codigoBarra || "");
    this.setGtin(dadosCsv.gtin || "");
    this.grupoProdutoId = dadosCsv.grupoProdutoId;
    this.subgrupoProdutoId = dadosCsv.subgrupoProdutoId;
    this.familiaProdutoId = dadosCsv.familiaProdutoId;
    this.subfamiliaProdutoId = dadosCsv.subfamiliaProdutoId;
    this.tipo = dadosCsv.tipo;
    this.descricao = dadosCsv.descricao;
    this.unidadeComercialCompraId = dadosCsv.unidadeComercialCompraId;
    this.unidadeComercialVendaId = dadosCsv.unidadeComercialVendaId;
    this.conversorEntrada = dadosCsv.conversorEntrada;
    this.estoqueAtual = dadosCsv.estoqueAtual;
    this.estoque = dadosCsv.estoque;
    this.fracionavel = dadosCsv.fracionavel === "true";
    this.lerPesoPorBalanca = dadosCsv.lerPesoPorBalanca;
    this.precoCompra = dadosCsv.precoCompra;
    this.precoCusto = dadosCsv.precoCusto;
    this.precoVenda = dadosCsv.precoVenda;
    this.precoMedio = dadosCsv.precoMedio;
    this.lucroDesejado = dadosCsv.lucroDesejado;
    this.grupoTributacaoId = dadosCsv.grupoTributacaoId;
    this.tipoItemId = dadosCsv.tipoItemId;
    this.ncmId = ncmEncontrado?.id;
    this.ncmCodigo = ncmEncontrado?.codigo;
    this.cestId = cestEncontrado?.id;
    this.cestCodigo = cestEncontrado?.codigo;
    this.origemMercadoriaId = dadosCsv.origemMercadoriaId;
    this.aliquotaMva = dadosCsv.aliquotaMva;
    this.informacaoAdicionalNfe = dadosCsv.informacaoAdicionalNfe;
    this.informacaoComplementar = dadosCsv.informacaoComplementar;
    this.produtosSimilaresIds = dadosCsv.produtosSimilaresIds || [];
    this.produtosKitIds = dadosCsv.produtosKitIds || [];
    this.fornecedores = dadosCsv.fornecedores || [];
    this.produtosGrade = dadosCsv.produtosGrade || [];
    this.tagsIds = dadosCsv.tagsIds || [];
    this.hubVendas = dadosCsv.hubVendas;
    this.altura = dadosCsv.altura;
    this.largura = dadosCsv.largura;
    this.comprimento = dadosCsv.comprimento;
    this.peso = dadosCsv.peso;
    this.isMedicamento = dadosCsv.isMedicamento === "true";
    this.isCombustivel = dadosCsv.isCombustivel === "true";
    this.dataValidade = dadosCsv.dataValidade;
    this.dataFabricacao = dadosCsv.dataFabricacao;
    this.precoMaxConsumo = dadosCsv.precoMaxConsumo;
    this.numLote = dadosCsv.numLote;
    this.qtdLote = dadosCsv.qtdLote;
    this.agregado = dadosCsv.agregado;
    this.prodAnvisa = dadosCsv.prodAnvisa;
    this.motivoIsencao = dadosCsv.motivoIsencao;
    this.anpCodigo = dadosCsv.anpCodigo;
    this.anpDescricao = dadosCsv.anpDescricao;
    this.unidadeTributavelId = dadosCsv.unidadeTributavelId;
    this.anpDescricao = dadosCsv.anpDescricao;
    this.unidadeTributavelId = dadosCsv.unidadeTributavelId;
    this.qtdTributavel = dadosCsv.qtdTributavel;
    this.glp = dadosCsv.glp;
    this.gasNaturalNacional = dadosCsv.gasNaturalNacional;
    this.gasNaturalImp = dadosCsv.gasNaturalImp;
    this.valorPartida = dadosCsv.valorPartida;
    this.codif = dadosCsv.codif;
    this.qtdCombTempAmbiente = dadosCsv.qtdCombTempAmbiente;
    this.bcCide = dadosCsv.bcCide;
    this.aliquotaCide = dadosCsv.aliquotaCide;
    this.bcCide = dadosCsv.bcCide;
    this.aliquotaCide = dadosCsv.aliquotaCide;
    this.valorCide = dadosCsv.valorCide;
    this.indicadorImportacao = dadosCsv.indicadorImportacao;
    this.ufOrigem = dadosCsv.ufOrigem;
    this.percentualUf = dadosCsv.percentualUf;
    this.referenciaPeca = dadosCsv.referenciaPeca;
    if (dadosCsv.enderecoEstoque) {
      const enderecoEstoqueEncontrado = listaEnderecoEstoque.find(
        (item) =>
          item.endereco === dadosCsv.enderecoEstoque.trim().toUpperCase(),
      );
      this.enderecoEstoqueId = enderecoEstoqueEncontrado.id;
    }
  }

  setCodigoBarra(codigoBarra) {
    if (codigoBarra && codigoBarra.toString().replace(/\s/g, "") !== "") {
      this.codigoBarra = String(codigoBarra);
    } else this.codigoBarra = null;
  }

  setGtin(gtin) {
    if (gtin && gtin.toString().replace(/\s/g, "") !== "") {
      this.gtin = String(gtin);
    } else this.gtin = null;
  }
}
